var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-popover',_vm._g(_vm._b({attrs:{"container":"#container"}},'b-popover',_vm.$attrs,false),_vm.mountEventListeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }